var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.openModal
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "modal fade show",
            staticStyle: { display: "block" },
            attrs: {
              id: "go-modal-email-certify",
              tabindex: "-1",
              "aria-hidden": "true",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog go-modal-prompt blank" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.isEmail
                          ? _vm.$t("myPage.button.editEmailInfo")
                          : _vm.$t("myPage.button.editPhoneInfo")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.close },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-area" }, [
                    !_vm.isEmail
                      ? _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "go-form-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("myPage.profile.titlePhoneInput"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-input-group" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.countrySelect,
                                    expression: "countrySelect",
                                  },
                                ],
                                staticClass: "go-form-control cell",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.countrySelect = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { disabled: "", selected: "" },
                                    domProps: { value: null },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "myPage.profile.selectPhoneCountry"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.countries, function (country) {
                                  return _c(
                                    "option",
                                    {
                                      key: country.label,
                                      domProps: { value: country.value },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(country.label) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.registerFormModel.phoneNumber,
                                  expression: "registerFormModel.phoneNumber",
                                },
                                { name: "autotrim", rawName: "v-autotrim" },
                              ],
                              staticClass: "go-form-control",
                              staticStyle: { "margin-left": "0.5rem" },
                              attrs: {
                                type: "tel",
                                placeholder: _vm.$t(
                                  "register.betaMessage.form.enterValidPhone"
                                ),
                                maxlength: "40",
                                disabled: _vm.isSendingCode,
                              },
                              domProps: {
                                value: _vm.registerFormModel.phoneNumber,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.registerFormModel,
                                      "phoneNumber",
                                      $event.target.value
                                    )
                                  },
                                  _vm.checkRegexPhone,
                                ],
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.getVerificationCode()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "go-input-group-append" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn go-btn-outline-primary",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        !_vm.countrySelect ||
                                        _vm.isSendingCode ||
                                        !_vm.registerFormModel.phoneNumber
                                          .length ||
                                        _vm.isInvalidMailOrPhone,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.getVerificationCode()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "register.betaMessage.form.btnSend"
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.registerFormModel.phoneNumber &&
                          _vm.registerFormModel.phoneNumber.length > 0 &&
                          !_vm.countrySelect
                            ? _c(
                                "div",
                                { staticClass: "go-form-feedback-invalid" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "myPage.profile.requiredPhoneCountry"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : !_vm.registerFormModel.phoneNumber.length &&
                              !_vm.isEmail &&
                              _vm.changedInput
                            ? _c(
                                "div",
                                { staticClass: "go-form-feedback-invalid" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "register.betaMessage.form.enterPhone"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : (!_vm.checkRegexPhone() &&
                                !_vm.isEmail &&
                                _vm.changedInput) ||
                              _vm.isInCorrectPhone
                            ? _c(
                                "div",
                                { staticClass: "go-form-feedback-invalid" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "register.betaMessage.form.invalidPhone"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _vm.existedMailOrPhone
                            ? _c(
                                "div",
                                { staticClass: "go-form-feedback-invalid" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "register.betaMessage.form.existPhone"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _vm.isShowResendCode
                            ? _c("div", { staticClass: "go-form-feedback" }, [
                                _c(
                                  "div",
                                  { staticClass: "go-form-feedback-valid" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "register.betaMessage.form.resendPhoneCode.codeSent"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-info-box" }, [
                                  _c("div", { staticClass: "go-info-title" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "register.betaMessage.form.resendPhoneCode.notGotCode"
                                          )
                                        )
                                    ),
                                    _c(
                                      "a",
                                      {
                                        class: {
                                          notAllowClick:
                                            _vm.isSendingCode ||
                                            !_vm.registerFormModel.phoneNumber
                                              .length ||
                                            !_vm.checkRegexPhone(),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getVerificationCode()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "register.betaMessage.form.resendPhoneCode.resend"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ul", { staticClass: "go-info-list" }, [
                                    _c("li", { staticClass: "go-list-item" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "register.betaMessage.form.resendPhoneCode.checkCorrectPhone"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", { staticClass: "go-list-item" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "register.betaMessage.form.resendPhoneCode.checkSpamMessage"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                        ])
                      : _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "go-form-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("register.betaMessage.form.emailId")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.registerFormModel.email,
                                  expression: "registerFormModel.email",
                                },
                                { name: "autotrim", rawName: "v-autotrim" },
                              ],
                              staticClass: "go-form-control",
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t(
                                  "register.betaMessage.form.enterEmail"
                                ),
                                maxlength: "40",
                                disabled: _vm.isSendingCode,
                              },
                              domProps: { value: _vm.registerFormModel.email },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.registerFormModel,
                                      "email",
                                      $event.target.value
                                    )
                                  },
                                  _vm.checkRegexEmail,
                                ],
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.stopPropagation()
                                  return _vm.getVerificationCode()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "go-input-group-append" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn go-btn-outline-primary",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.isSendingCode ||
                                        !_vm.registerFormModel.email.length ||
                                        _vm.isInvalidMailOrPhone,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.getVerificationCode()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "register.betaMessage.form.btnSend"
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          !_vm.registerFormModel.email.length &&
                          _vm.changedInput
                            ? _c(
                                "div",
                                { staticClass: "go-form-feedback-invalid" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "register.betaMessage.form.enterEmail2"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _vm.isInvalidMailOrPhone
                            ? _c(
                                "div",
                                { staticClass: "go-form-feedback-invalid" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "register.betaMessage.form.invalidEmail"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _vm.existedMailOrPhone
                            ? _c(
                                "div",
                                { staticClass: "go-form-feedback-invalid" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "register.betaMessage.form.existEmail"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _vm.isShowResendCode
                            ? _c("div", { staticClass: "go-form-feedback" }, [
                                _c(
                                  "div",
                                  { staticClass: "go-form-feedback-valid" },
                                  [_vm._v(_vm._s(_vm.$t("register.sentCode")))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-info-box" }, [
                                  _c("div", { staticClass: "go-info-title" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "register.betaMessage.form.notReceiveCode"
                                          )
                                        )
                                    ),
                                    _c(
                                      "a",
                                      {
                                        class: {
                                          notAllowClick:
                                            _vm.isVerificationCodeSuccess &&
                                            _vm.isSendingCode,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getVerificationCode()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("register.resend"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ul", { staticClass: "go-info-list" }, [
                                    _c("li", { staticClass: "go-list-item" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "register.betaMessage.form.resendEmailCode.checkCorrectEmail"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", { staticClass: "go-list-item" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "register.betaMessage.form.resendEmailCode.checkSpamMessage"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", { staticClass: "go-list-item" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "register.betaMessage.form.resendEmailCode.checkMailboxCapacity"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", {
                        staticClass: "go-form-label",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("register.betaMessage.form.enterCode")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-input-group" }, [
                        _c("div", { staticClass: "go-input-group-floating" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.confirmCode,
                                expression: "confirmCode",
                              },
                            ],
                            staticClass: "go-form-control",
                            staticStyle: { "padding-right": "5rem" },
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "register.betaMessage.form.enterCode2"
                              ),
                              maxlength: "6",
                              disabled:
                                _vm.isVerificationCodeSuccess &&
                                _vm.isSendingCode,
                            },
                            domProps: { value: _vm.confirmCode },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.confirmCode = $event.target.value
                                },
                                _vm.checkRegexCode,
                              ],
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.confirm()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.isSendingCode
                            ? _c("div", { staticClass: "go-form-timer" }, [
                                _vm._v(
                                  _vm._s(_vm.minLeft) +
                                    ":" +
                                    _vm._s(_vm.secLeft)
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-outline-primary",
                              attrs: {
                                type: "button",
                                disabled:
                                  !_vm.isSendingCode ||
                                  !_vm.checkRegexCode() ||
                                  _vm.confirmCode.length < 6 ||
                                  (_vm.isVerificationCodeSuccess &&
                                    _vm.isSendingCode) ||
                                  (!_vm.isVerificationCodeSuccess &&
                                    _vm.sendedVerificationCode &&
                                    _vm.isSendingCode &&
                                    !_vm.isReConFirmCode),
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.confirm()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.verifyCode"
                                    )
                                  ) +
                                  "\n                  "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.confirmCode.length && _vm.isSendingCode
                        ? _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.verifyCode2"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          )
                        : (!_vm.checkRegexCode() || _vm.confirmCode.length) <
                            6 && _vm.isSendingCode
                        ? _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.invalidCode"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          )
                        : _vm.isExpiredCode
                        ? _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.expiredCode"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          )
                        : _vm.isVerificationCodeSuccess && _vm.isSendingCode
                        ? _c("div", { staticClass: "go-form-feedback-valid" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t("register.betaMessage.form.validCode")
                                ) +
                                "\n              "
                            ),
                          ])
                        : !_vm.isVerificationCodeSuccess &&
                          _vm.sendedVerificationCode &&
                          _vm.isSendingCode &&
                          !_vm.isReConFirmCode
                        ? _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "register.betaMessage.form.invalidCode"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v(_vm._s(_vm.$t("myPage.button.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-primary",
                      attrs: {
                        type: "button",
                        disabled: !_vm.isVerificationCodeSuccess,
                      },
                      on: { click: _vm.save },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("myPage.button.save")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal-backdrop fade show" }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }